import { yupResolver } from '@hookform/resolvers/yup'
import { useTranslation } from 'libs/i18n'
import * as yup from 'yup'

export const useNameValidationSchema = () => {
	const { t } = useTranslation()

	const nameValidationSchema = yup.object({
		name: yup.string().required(t('Name is required'))
	})

	return yupResolver(nameValidationSchema)
}
